<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-card style="">
            <v-card-text>
              <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Booking No : AME/FF/17082002</h3>
                <v-btn flat class="primary" style="margin-left:700px;margin-bottom: 10px" v-on:click="back()">Back</v-btn>
              </v-layout>
              <v-divider divider: true></v-divider>
              <p style="margin-top:20px;text-align: left"><v-btn v-on:click="sho1()" flat>1.Overview</v-btn> / <v-btn v-on:click="sho2()" flat>2.Document</v-btn>/ <v-btn v-on:click="sho3()" flat>3.Containers</v-btn>/ <v-btn v-on:click="sho4()" flat>4.Log</v-btn></p>
              <v-layout row wrap v-show="show1">
                <v-flex xs2 child-flex style="margin-top: 10px;text-align:left;margin-left:20px">
                  <p><b>Place of Receipt</b></p>
                  <p>Dammam Saudi Arabia on OCT 10 2016 at 10:00</p>
                </v-flex>
                <v-divider vertical></v-divider>
                <v-flex xs7 style="margin-top: 10px;text-align: center">
                  <v-layout row wrap>
                    <v-flex xs3 child-flex style="margin-left:20px">
                      <p><b>Port of Loading</b></p>
                      <v-icon style="margin-left:70px;color:#1565C0">map_marker</v-icon>
                      <p>Dammam Saudi Arabia on OCT 16 2010</p>
                    </v-flex>
                    <v-flex xs5 child-flex>
                      <p>Ocean Transit Time<b> 25 Days</b></p>
                      <v-progress-linear
                        slot="progress"
                        :value="50"
                        :color= "blue"
                        height="7"
                        style="margin-top:20px;margin-left:30px;width:250px;margin-right:30px"
                        align-center
                      ></v-progress-linear>
                      <p>Original Transit Time<b> 32 Days</b></p>
                    </v-flex>
                    <v-flex xs3 child-flex>
                      <p><b>Port of Discharge</b></p>
                      <v-icon style="margin-left:70px;color:#1565C0">map_marker</v-icon>
                      <p>Dammam Saudi Arabia on OCT 16 2010</p>
                    </v-flex>
                  </v-layout>
                  <v-card style="margin-top:30px;width:400px;margin-left:150px">
                      <v-card-text>
                        <p><b>Status :</b> Early by 1 days</p>
                        <p><b>ETA Change Reason :</b> Vessal arrival has changed</p>
                      </v-card-text>
                  </v-card>
                </v-flex>
                <v-divider vertical></v-divider>
                <v-flex xs2 child-flex style="margin-top: 10px;text-align: left;margin-left:20px">
                  <p><b>Place of Delivery</b></p>
                  <p>Port Sudan, Sudan On Nov 11 2016 at 07:00</p>
                </v-flex>
              </v-layout>
              <v-flex v-show="show2">
                <v-flex d-flex>
                        <v-data-table
                          :headers="headers1"
                          :items="desserts1"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.calories }}</td>
                            <td class="text-xs-left">{{ props.item.fat }}</td>
                            <td class="text-xs-left">{{ props.item.carbs }}</td>
                          </template>
                        </v-data-table>
                </v-flex>
              </v-flex>
              <v-flex v-show="show3">
                <v-flex d-flex>
                        <v-data-table
                          :headers="headers2"
                          :items="desserts2"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.containerno }}</td>
                            <td class="text-xs-left">{{ props.item.commodity}}</td>
                            <td class="text-xs-left">{{ props.item.netwt }}</td>
                            <td class="text-xs-left">{{ props.item.grosswt }}</td>
                            <td class="text-xs-left">{{ props.item.dangerous }}</td>
                            <td class="text-xs-left">{{ props.item.oversized }}</td>
                            <td class="text-xs-left">{{ props.item.tempcontrl }}</td>
                            <td class="text-xs-left">{{ props.item.vgmwt }}</td>
                            <td class="text-xs-left">{{ props.item.view }}</td>
                          </template>
                        </v-data-table>
                </v-flex>
              </v-flex>
              <v-flex v-show="show4">
                <v-flex d-flex>
                        <v-data-table
                          :headers="headers5"
                          :items="desserts5"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td>{{ props.item.no}}</td>
                            <td class="text-xs-left">{{ props.item.action }}</td>
                            <td class="text-xs-left">{{ props.item.users}}</td>
                            <td class="text-xs-left">{{ props.item.company }}</td>
                            <td class="text-xs-left">{{ props.item.dateandtime }}</td>
                          </template>
                        </v-data-table>
                </v-flex>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12>
          <v-layout column v-show="show1">
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Detailed Transport Plan</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs12 child-flex style="text-align: right;margin-top:20px">
                      <v-layout row wrap>
                        <p>All the test time are given as reasonable estsmates only and subject to change without prior notice</p>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.calories }}</td>
                      <td class="text-xs-left">{{ props.item.fat }}</td>
                      <td class="text-xs-left">{{ props.item.carbs }}</td>
                      <td class="text-xs-left">{{ props.item.protein }}</td>
                      <td class="text-xs-left">{{ props.item.iron }}</td>
                      <td class="text-xs-left">{{ props.item.status}}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                      <v-card-text>
                        <h3 style="text-align: left;margin-bottom: 10px">Parties</h3>
                        <v-divider divider: true></v-divider>
                        <v-layout row wrap>
                          <v-flex xs3 child-flex style="margin-top:20px;text-align: left;margin-left: 120px">
                            <p><b>Shipper</b></p>
                            <p>National Petroch Chemical LTD </p>
                            <p>Marketing Co PO Box No 26707</p>
                            <p>Tel : +966258741369</p>
                          </v-flex>
                          <v-flex xs3 child-flex style="margin-top:20px;text-align: left;margin-left: 70px">
                            <p><b>Consignee</b></p>
                            <p>National Petroch Chemical LTD </p>
                            <p>Marketing Co PO Box No 26707</p>
                            <p>Tel : +966258741369</p>
                          </v-flex>
                          <v-flex xs3 child-flex style="margin-top:20px;text-align: left;margin-left: 70px">
                            <p><b>Booked By</b></p>
                            <p>Rohit Supe OGD Bapodi</p>
                            <p>Pune 42</p>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs3 child-flex style="margin-top:20px;text-align: left;margin-left: 120px">
                            <p><b>FNP (First Notify Party)</b></p>
                            <p>National Petroch Chemical LTD </p>
                            <p>Marketing Co PO Box No 26707</p>
                            <p>Tel : +966258741369</p>
                          </v-flex>
                          <v-flex xs3 child-flex style="margin-top:20px;text-align: left;margin-left: 70px">
                            <p><b>SNP (Second Notify Party)</b></p>
                            <p>National Petroch Chemical LTD </p>
                            <p>Marketing Co PO Box No 26707</p>
                            <p>Tel : +966258741369</p>
                          </v-flex>
                          <v-flex xs3 child-flex style="margin-top:20px;text-align: left;margin-left: 70px">
                            <p><b>Transport Document Receiver</b></p>
                            <p>Reliance Corporate IT Park</p>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
            </v-flex>
          </v-layout>
          <v-layout column v-show="show3">
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Detailed Transport Plan</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs12 child-flex style="text-align: right;margin-top:20px">
                      <v-layout row wrap>
                        <p>For Container No: MSKU895632</p>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers3"
                    :items="desserts3"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.conatinerevent }}</td>
                      <td class="text-xs-left">{{ props.item.location }}</td>
                      <td class="text-xs-left">{{ props.item.dateandtime }}</td>
                    </template>
                  </v-data-table>
                  <v-data-table
                    :headers="headers4"
                    :items="desserts4"
                    class="elevation-1"
                    style="margin-top: 20px"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.containerseal }}</td>
                      <td class="text-xs-left">{{ props.item.sealnumber }}</td>
                      <td class="text-xs-left">{{ props.item.dateandtime }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Date', value: 'calories' },
        { text: 'Time', value: 'fat' },
        { text: 'Event', value: 'carbs' },
        { text: 'Terminal', value: 'protein' },
        { text: 'Voyage No', value: 'iron' },
        { text: 'Transport Via', value: 'status' }
      ],
      desserts: [
        {
          no: '1',
          calories: '17-Oct-2016',
          fat: '10:00',
          carbs: 'Departs from Dammam Saudi Arabia',
          protein: 'Dammam',
          iron: '1612',
          status: 'MAERSK SHAM'
        },
        {
          no: '2',
          calories: '18-Oct-2016',
          fat: '10:00',
          carbs: 'Departs from Dammam Saudi Arabia',
          protein: 'Dammam',
          iron: '1612',
          status: 'MAERSK SHAM'
        },
        {
          no: '3',
          calories: '01-NOV-2016',
          fat: '10:00',
          carbs: 'Departs from Dammam Saudi Arabia',
          protein: 'Dammam',
          iron: '1612',
          status: 'MAERSK SHAM'
        }
      ],
      headers1: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'File Name', value: 'calories' },
        { text: 'Date Created', value: 'fat' },
        { text: 'Remarks', value: 'carbs' }
      ],
      desserts1: [
        {
          no: '1',
          calories: 'Verify Copy',
          fat: '17-Oct-2016',
          carbs: 'Approved on 18-Oct-2016'
        },
        {
          no: '2',
          calories: 'Verify Bill of Landing',
          fat: '18-Oct-2016',
          carbs: 'Transport Document Created'
        },
        {
          no: '3',
          calories: 'Verify arrival notice',
          fat: '23-Nov-2016',
          carbs: ''
        }
      ],
      headers2: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Container No', value: 'containerno' },
        { text: 'Commodity', value: 'commodity' },
        { text: 'Net Wt', value: 'netwt' },
        { text: 'Gross Wt', value: 'grosswt' },
        { text: 'Dangerous', value: 'dangerous' },
        { text: 'Oversized', value: 'oversized' },
        { text: 'Temp. Contrl', value: 'tempcontrl' },
        { text: 'VGM Wt', value: 'vgmwt' },
        { text: 'View', value: 'view' }
      ],
      desserts2: [
        {
          no: '1',
          containerno: 'MSKU895632',
          commodity: 'Synthetic, Raisin Plastic',
          netwt: '24.29',
          grosswt: '32.46',
          dangerous: 'No',
          oversized: 'No',
          tempcontrl: 'No',
          vgmwt: '37.17',
          view: 'Show Details'
        },
        {
          no: '2',
          containerno: 'MSKU8956856',
          commodity: 'Synthetic, Raisin Plastic',
          netwt: '24.29',
          grosswt: '32.46',
          dangerous: 'No',
          oversized: 'No',
          tempcontrl: 'No',
          vgmwt: '37.17',
          view: 'Show Details'
        }
      ],
      headers3: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Container Event', value: 'conatinerevent' },
        { text: 'Location', value: 'location' },
        { text: 'Date and Time', value: 'dateandtime' }
      ],
      desserts3: [
        {
          no: '1',
          conatinerevent: 'Loaded container on MAERSKSHAM',
          location: 'Dammam, Saudi Arabia',
          dateandtime: '17-Oct-2016, 03:08'
        },
        {
          no: '2',
          conatinerevent: 'Discharge loaded container',
          location: 'Jabei Ali, UA8',
          dateandtime: '17-Oct-2016, 00:48'
        }
      ],
      headers4: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Container Seal', value: 'containerseal' },
        { text: 'Seal Number', value: 'sealnumber' },
        { text: 'Date and Time', value: 'dateandtime' }
      ],
      desserts4: [
        {
          no: '1',
          containerseal: 'Shipper Seal',
          sealnumber: '253698',
          dateandtime: '18-Oct-2016, 04:08'
        },
        {
          no: '2',
          containerseal: 'Shipper Seal',
          sealnumber: '896547',
          dateandtime: '18-Oct-2016, 05:48'
        }
      ],
      headers5: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Action', value: 'action' },
        { text: 'Users', value: 'users' },
        { text: 'Company', value: 'company' },
        { text: 'Date and Time', value: 'dateandtime' }
      ],
      desserts5: [
        {
          no: '1',
          action: 'Booking Confirmned',
          users: 'Rohit Supe',
          company: 'Reliance IT LTD',
          dateandtime: '18-Oct-2016, 04:08'
        },
        {
          no: '2',
          action: 'Booking Confirmned By',
          users: 'Rohit Supe',
          company: 'MAERSK',
          dateandtime: '19-Oct-2016, 11:48'
        },
        {
          no: '3',
          action: 'Shipping Instructions Submitted',
          users: 'Yogesh Wagh',
          company: 'Wynum Logistics',
          dateandtime: '22-Oct-2016, 11:48'
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      show4: false
    }
  },
  mounted () {
    console.log('bulkbooking page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
      this.show4 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
      this.show4 = false
    },
    sho3 () {
      this.show3 = true
      this.show2 = false
      this.show1 = false
      this.show4 = false
    },
    sho4 () {
      this.show4 = true
      this.show2 = false
      this.show1 = false
      this.show3 = false
    },
    back () {
      this.$router.push('/Dashboard')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Trackyourshipment.vue